import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

export async function analysisSampleList(
  account_id: string,
  query?: { [key: string]: any },
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/analysis/sample/list${queryString}`,
  );
}

export async function analysisSampleCreate(
  account_id: string,
  payload: {
    evaluation_id: string;
    analysis_id: string;
    sample_id: string;
  },
) {
  return await clientAxios.post(
    `account/${account_id}/analysis/sample/create`,
    payload,
  );
}

export async function analysisSampleDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/analysis/sample/${item_id}/delete`,
  );
}
